import { nanoid } from 'nanoid'
import { useEffect, useState } from "react"
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, user, toggle, pdfManager,
    FetchData,
    Helpers,

    defaultData,

    //------------- Forms
    Forms,

    globalStates

}) => {

    const navigate = useNavigate();

    const { convertToFloat, paymentCalculation, drawPaymentTicket } = Helpers


    // Formateador de números
    const numberFormatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        maximumFractionDigits: 2
    });


    const openModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }

    const closeModal = () => {
        toggle()
    }

    const handleClickShowModal = (_, title, compont, dataRequest, modalOpeningMode) => {
        const { setModalOpeningMode } = globalStates
        setModalOpeningMode(modalOpeningMode)
        openModal(_, title, compont, dataRequest)
    }

    const handleClickCloseModal = () => {

        //HOOKS
        const { FormDeposit } = Forms
        const { onResetForm } = FormDeposit
        onResetForm()
        closeModal()
    }

    const handleClickCloseForm = () => {
        const { FormRequestGlobal } = Forms
        const { onResetForm } = FormRequestGlobal
        onResetForm()
        // navigate si funcionó
        navigate('/gestiones-vehiculos-gestiones')
    }


    const handleChangeContract = async (event) => {

        //HOOKS
        const { FormRequestGlobal } = Forms
        const { setFormState, formState } = FormRequestGlobal

        const { setShowFormContract, showFormContract } = globalStates

        const { fetchInfoContract: { executeFetchInfoContract } } = FetchData

        const { name, value } = event.target

        setFormState(prevState => ({
            ...prevState,
            [name]: value
        }))

        await executeFetchInfoContract()

        setShowFormContract(true)
    }

    const onSubmitFormRequests = async (e) => {
        e.preventDefault()


        const { FormRequestGlobal } = Forms
        const { formState } = FormRequestGlobal

        const {
            identifySelectedRequestType,
            getBodyForDateChange,
            getBodyForGPSRemoval,
            getBodyForContractTermination,
            getBodyForTotalInsurancePayment,
            getBodyForUncollectibleAccounts,
            getBodyForGPSExemption,
            getBodyForExtraordinaryTermination,
            getBodyForCreditRefinancion,
            getBodyForPaymentReversal,
            getBodyForMoraExemption
        } = Helpers

        const { fetchAllTypeManagements: { typeManagements } } = FetchData

        const isForUpdate = (formState.idgestion > 0) //Flag para actualizar

        let _body

        //Validaciones generales
        if (formState.idgestiontipo == 0) {
            const messageCustom = {
                message: 'Debe seleccionar una gestion',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (formState.idcredito == 0) {
            const messageCustom = {
                message: 'Debe seleccionar un contrato',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        //Switch para validaciones y body personalizados
        switch (identifySelectedRequestType(typeManagements, formState.idgestiontipo)) {
            case 'CFP':{
                _body = await getBodyForDateChange({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'PTS':{
                _body = await getBodyForTotalInsurancePayment({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'RGPS':{
                _body = await getBodyForGPSRemoval({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'FDC':{
                _body = await getBodyForContractTermination({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'ECJ':{
                _body = await getBodyForUncollectibleAccounts({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'EXGPS':{
                _body = await getBodyForGPSExemption({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'FEC':{
                _body = await getBodyForExtraordinaryTermination({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'REF':{
                const nuevoDiaPago = FormRequestGlobal.formState.gestion_nuevo_dia_pago
                const refMessage = !(parseFloat(FormRequestGlobal.formState.clean_saldo_financiado) > 0)
                    ? 'Debe indicar el monto a refinanciar'
                    : !(parseFloat(FormRequestGlobal.formState.interes) > 0)
                    ? 'Debe indicar el tipo de interes'
                    : !(parseInt(FormRequestGlobal.formState.nuevo_plazo, 10) > 0)
                    ? 'Debe indicar el plazo en meses'
                    : !nuevoDiaPago
                    ? 'Debe indicar el nuevo dia de pago'
                    : (parseInt(nuevoDiaPago.split('-')[2], 10) === 31)
                        ? 'El dia 31 no puede ser asignado como dia de pago'
                        : (nuevoDiaPago < Helpers.getCurrentDate())
                            ? 'El nuevo dia de pago no puede ser una fecha pasada'
                            : null
                if (refMessage) {
                    alertMessage({ message: refMessage, title: 'FAIL', rows: [] })
                    return
                }
                _body = await getBodyForCreditRefinancion({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'EXCF':{
                _body = await getBodyForGPSExemption({ user, FormRequestGlobal, isForUpdate })
                break;
            }
            case 'RDP': {
                _body = await getBodyForPaymentReversal({ user, FormRequestGlobal, isForUpdate })
                break
            }
            case 'EXM': {
                if (!formState.rowSelectedExoneracion || formState.rowSelectedExoneracion.length === 0) {
                    alertMessage({ title: 'FAIL', message: 'Debe seleccionar al menos una cuota con mora pendiente', rows: [] })
                    return
                }
                if (!formState.clean_porcentaje_exoneracion || formState.clean_porcentaje_exoneracion <= 0 || formState.clean_porcentaje_exoneracion > 100) {
                    alertMessage({ title: 'FAIL', message: 'El porcentaje de exoneración debe ser mayor a 0% y no puede exceder el 100%', rows: [] })
                    return
                }
                _body = await getBodyForMoraExemption({ user, FormRequestGlobal, isForUpdate })
                break
            }
            default:
                console.log('__error, no es posible identificar el tipo de gestión')
                return
        }

        console.log('[useActions][onSubmitFormRequests] _body ::: ', _body)
        
        // Validamos si vamos a actualizar o insertar
        if (isForUpdate) {
            await marvarApi.put(`/vehicle/mgmt-managements/update-management/${formState.idgestion}`, _body)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        handleClickCloseForm()
                    }
                })
        } else {
            await marvarApi.post(`/vehicle/mgmt-managements/${formState.idcredito}`, _body)
                .then(({ data }) => {
                    alertMessage(data)
                    if (data.title === 'OK') {
                        handleClickCloseForm()
                    }
                })
        }

        // console.log(_body);

    }

    const onSendLogs = async (e) => {


        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const { fetchInfoObservations: { executeFetchAllObservations } } = FetchData


        const { getCurrentDate } = Helpers

        // const { fetchAllTypeManagements:{typeManagements} } = FetchData

        await marvarApi.post(`/vehicle/common/log-management/${formState.idgestion}`, {
            idusuario: user.uid,
            log_fecha: getCurrentDate(),
            log_observacion: formState.aprobacion_observaciones,
            log_departamento: "Gestor"
        })
            .then(({ data }) => {
                alertMessage(data)
                if (data.title === 'OK') {
                    setFormState((prevState) => ({
                        ...prevState,
                        aprobacion_observaciones: ''
                    }))
                    executeFetchAllObservations()
                }
            })
    }

    const handleChangeTypeCurrency = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto, deposito_tipo_cambio } = formState

        const { name, value } = event.target

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? deposito_tipo_cambio : 0;


        if (value === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (value === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (clean_deposito_monto / tipo_cambio)
            }))
        }
    }

    const handleChangeAmount = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState, onInputChangeForNumber } = FormDeposit
        const { deposito_tipo_cambio } = formState

        const { value } = event.target

        onInputChangeForNumber(event)
        const clean_value = convertToFloat(value)

        //Verificamos si tiene data
        const tipo_cambio = deposito_tipo_cambio !== '' ? parseFloat(deposito_tipo_cambio) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_value),
                clean_deposito_quetzales: (clean_value * tipo_cambio),
                clean_deposito_dolares: clean_value
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                deposito_quetzales: numberFormatter.format(clean_value),
                deposito_dolares: numberFormatter.format(clean_value / tipo_cambio),
                clean_deposito_quetzales: clean_value,
                clean_deposito_dolares: (clean_value / tipo_cambio)
            }))
        }
    }

    const handleChangeExchangeRate = (event) => {

        //HOOKS
        const { FormDeposit } = Forms
        const { setFormState, formState } = FormDeposit
        const { clean_deposito_monto } = formState

        const { name, value } = event.target

        const tipo_cambio = value !== '' ? parseFloat(value) : 0;

        if (formState.deposito_moneda === 'DOLAR') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto * tipo_cambio),
                deposito_dolares: numberFormatter.format(clean_deposito_monto),
                clean_deposito_quetzales: (clean_deposito_monto * tipo_cambio),
                clean_deposito_dolares: clean_deposito_monto
            }))
        } else if (formState.deposito_moneda === 'QUETZAL') {
            setFormState(prevState => ({
                ...prevState,
                [name]: value,
                deposito_quetzales: numberFormatter.format(clean_deposito_monto),
                deposito_dolares: (tipo_cambio === 0) ? 0 : numberFormatter.format(clean_deposito_monto / tipo_cambio),
                clean_deposito_quetzales: clean_deposito_monto,
                clean_deposito_dolares: (tipo_cambio === 0) ? 0 : (clean_deposito_monto / tipo_cambio)
            }))
        } else {
            setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))
        }
    }

    const onSubmitFormDeposits = async (e) => {

        e.preventDefault()

        const { FormDeposit, FormRequestGlobal } = Forms
        const { formState, onResetForm } = FormDeposit
        const formStateGlobal = FormRequestGlobal.formState

        const { fetchAllDeposits } = FetchData
        const { executeFetchAllDeposits } = fetchAllDeposits

        const { getCurrentDate } = Helpers


        if (formState.movimiento_tipo === 'EFECTIVO') {

            const _data = {
                idcredito: formStateGlobal.idcredito,
                idgestiontipo: formStateGlobal.idgestiontipo,
                deposito_usuario: user.username,
                deposito_fecha: formState.deposito_fecha,
                movimiento_tipo: formState.movimiento_tipo,
                deposito_monto: formState.clean_deposito_monto,
                deposito_moneda: formState.deposito_moneda,
                deposito_tipo_cambio: formState.deposito_tipo_cambio,
                deposito_quetzal: formState.clean_deposito_quetzales,
                deposito_dolares: formState.clean_deposito_dolares,
                idcaja: formState.idcaja,
                deposito_observaciones: formState.deposito_observaciones,
                usuario_creo: user.username,
                fecha_creo: getCurrentDate()
            }

            await marvarApi.post(`/vehicle/mgmt-managements/create-deposit-cash`, _data)
                .then(async ({ data }) => {

                    alertMessage(data)

                    if (data.title === 'OK') {
                        onResetForm()
                        executeFetchAllDeposits()
                        closeModal()
                        await handleClickDownloadTicket(data.insertId)
                    }

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

            console.log(_data);

        }

    }

    const onSubmitFormFiles = async (e) => {

        e.preventDefault()

        const { FormRequestGlobal: { formState, setFormState } } = Forms
        const { getCurrentDate } = Helpers

        if (formState.acceptedFiles.length <= 0) {
            const messageCustom = {
                message: 'No se ha cargado nigun archivo',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        const _data = new FormData();

        _data.append('idgestiontipo', formState.idgestiontipo);
        _data.append('idcredito', formState.idcredito);
        _data.append('department', '');
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', getCurrentDate());


        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`attachmentt`, file);
        });

        if (formState.idcredito > 0) {

            await marvarApi.post(`/vehicle/mgmt-managements/create-document`, _data)
                .then(({ data }) => {

                    if (data.title === 'OK') {
                        setFormState(prevState => ({
                            ...prevState,
                            check_carta: true,
                            acceptedFiles: [],
                            fileRejections: []
                        }))
                    }
                    alertMessage(data)
                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })

        }
    }

    const handleClickFetchInfoDeposit = async (idmovimiento) => {

        const { FormDeposit: { onResetForm } } = Forms


        const { fetchInfoDeposit } = FetchData
        const { setParamsToSearch, executeFetchInfoDeposit } = fetchInfoDeposit

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        onResetForm()
        console.log(idmovimiento);


        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idmovimiento: idmovimiento })
        executeFetchInfoDeposit()

        // setParamsToSearchDeposit({idcontrato: idcontrato})

        handleClickShowModal('', 'Formulario de depositos', 'deposits-section', {}, 'READONLY')

    }

    const handleChangeTypeLoan = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChange } } = Forms
        const { clean_saldo_financiado, nuevo_plazo, clean_gps, clean_seguro, clean_otros } = formState

        const { name, value } = event.target


        onInputChange(event)
        const interes_float = (parseFloat(value) / 100).toFixed(4)

        const interes_total_data = parseFloat((value * 12).toFixed(2));
        // console.log(interes_float, interes_total_data);

        const cuota_niv = paymentCalculation(clean_saldo_financiado, 0, value, nuevo_plazo)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);


        setFormState(prevState => ({
            ...prevState,
            interes_total: `${interes_total_data} %`,
            nuevo_cuota_niv: numberFormatter.format(cuota_niv),
            clean_nuevo_cuota_niv: cuota_niv,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleChangeTerm = (event) => {

        const { name, value } = event.target

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState } } = Forms

        const {
            clean_saldo_financiado,
            clean_gps,
            clean_seguro,
            clean_otros,
            interes,
        } = formState
        const cuota_niv = paymentCalculation(clean_saldo_financiado, 0, interes, value)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros);


        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        setFormState(prevState => ({
            ...prevState,
            [name]: value,
            plazo_anios: (value / 12).toFixed(2),
            nuevo_cuota_niv: numberFormatter.format(cuota_niv),
            clean_nuevo_cuota_niv: cuota_niv,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }


    const handleChangeGPS = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target

        const clean_value = convertToFloat(value)

        const {
            clean_nuevo_cuota_niv,
            clean_seguro,
            clean_otros
        } = formState

        const cuota_total = (parseFloat(clean_nuevo_cuota_niv) + parseFloat(clean_value) + parseFloat(clean_otros) + parseFloat(clean_seguro));

        setFormState(prevState => ({
            ...prevState,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleChangeSeguro = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, onInputChangeForNumber, formState } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target

        const clean_value = convertToFloat(value)

        const {
            clean_nuevo_cuota_niv,
            clean_gps,
            clean_otros
        } = formState

        const cuota_total = parseFloat(clean_nuevo_cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_value) + parseFloat(clean_otros);

        //Verificamos si tiene data
        // const interes_total_data = interes_total !== '' ? interes_total : 0;

        setFormState(prevState => ({
            ...prevState,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,

        }))
    }

    const handleChangeOtros = (event) => {

        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms

        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        const {
            clean_nuevo_cuota_niv,
            clean_gps,
            clean_seguro
        } = formState

        const cuota_total = parseFloat(clean_nuevo_cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_value);

        setFormState(prevState => ({
            ...prevState,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleChangeMount = (event) => {


        //HOOKS
        const { FormRequestGlobal: { setFormState, formState, onInputChangeForNumber } } = Forms
        const {
            clean_gps,
            clean_seguro,
            clean_otros,
            nuevo_plazo,
            interes,
        } = formState
        onInputChangeForNumber(event)

        const { value } = event.target
        const clean_value = convertToFloat(value)

        const cuota_niv = paymentCalculation(clean_value, 0, interes, nuevo_plazo)
        const cuota_total = parseFloat(cuota_niv) + parseFloat(clean_gps) + parseFloat(clean_seguro) + parseFloat(clean_otros)

        // console.log(cuota_niv, cuota_total);

        setFormState(prevState => ({
            ...prevState,
            // [ name ]: value,
            nuevo_cuota_niv: numberFormatter.format(cuota_niv),
            clean_nuevo_cuota_niv: cuota_niv,
            nuevo_total_cuota: numberFormatter.format(cuota_total),
            clean_nuevo_total_cuota: cuota_total,
        }))
    }

    const handleClickDownloadTicket = async (idmovimiento) => {
        try {
            const response = await marvarApi.get(`/vehicle/mgmt-managements/get-deposit-by-ID/${idmovimiento}`)
            if (response.data.title === 'OK') {
                const _dataForPDF = {
                    idmovimiento: response.data.data.idmovimiento,
                    aprobacion_check: response.data.data.aprobacion_check,
                    datos_cliente: response.data.data.nombre_cliente,
                    movimiento_quetzales: numberFormatter.format(response.data.data.deposito_quetzal),
                    deposito_fecha: response.data.data.deposito_fecha,
                    contrato_codigo: `VEH${response.data.data.idcredito}`,
                    movimiento_tipo: response.data.data.movimiento_tipo,
                    movimiento_monto: numberFormatter.format(response.data.data.deposito_monto),
                    deposito_moneda: response.data.data.deposito_moneda,
                    deposito_tipo_cambio: response.data.data.deposito_tipo_cambio,
                    movimiento_dolares: numberFormatter.format(response.data.data.deposito_dolares),
                    descripcion_caja: response.data.data.nombre_caja,
                    descripcion_banco: response.data.data.nombre_banco,
                    boleta_numero: response.data.data.boleta_numero,
                    aprobacion_referencia_ach: response.data.data.aprobacion_referencia_ach,
                    deposito_observaciones: response.data.data.deposito_observaciones,
                    aprobacion_observaciones: response.data.data.aprobacion_observaciones,
                    gestion: response.data.data.gestion
                }

                drawPaymentTicket(pdfManager, _dataForPDF)
            }
        } catch (e) {
            console.log('API ERROR: ', e)
        }
    }

    const handleClickResetPaymentSelection = () => {
    
        const { stepApplilication, setStepApplilication, formOpeningMode } = globalStates
        const { FormRequestGlobal, FormDeposit } = Forms

        if (formOpeningMode === 'EDITABLE') {
            FormRequestGlobal.setFormState(prevState => ({
                ...prevState,
                rowSelectedPayments: [], // reseteamos la selección de pagos
                transactions: [] // reseteamos las transacciones asociadas
            }))

            FormDeposit.setFormState(prevState => ({
                ...prevState,
                idpago: '' // reseteamos el id pago para el formulario
            }))
        }

        setStepApplilication(stepApplilication - 1)
    }

    const handleClickFetchTransactionsByPayment = (event) => {
        
        const { name, value } = event.target

        const { stepApplilication, setStepApplilication, formOpeningMode } = globalStates
        const { fetchTransactionsByPayment } = FetchData

        const { FormRequestGlobal, FormDeposit } = Forms

        // console.log('[useActions][handleClickFetchTransactionsByPayment] { name, value } ', {name, value})
        // console.log('[useActions][handleClickFetchTransactionsByPayment] value[0] ', value[0])

        if (formOpeningMode === 'EDITABLE') {
            // Setea selección (como un onInputChange)
            FormRequestGlobal.setFormState(prevState => ({
                ...prevState,
                [name]: value
            }))

            // Registra id pago para formulario de deposito
            FormDeposit.setFormState(prevState => ({
                ...prevState,
                idpago: parseInt(value[0].idpago, 10)
            }))

            // fetch de transacciones por pago
            fetchTransactionsByPayment.setParamsToSearch({
                idpago: parseInt(value[0].idpago, 10)
            })
            fetchTransactionsByPayment.executeFetch()
        }

        // salta al siguiente paso
        setStepApplilication(stepApplilication + 1)
    }

    const handleClickTransactionForRetroactive = async () => {

        const { setModalOpeningMode } = globalStates
        const { FormDeposit } = Forms

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        const idpago = FormDeposit.formState.idpago

        // console.log('[useActions][handleClickTransactionForRetroactive] idpago ::: ', idpago)

        FormDeposit.onResetForm()
        FormDeposit.setFormState(prevState => ({
            ...prevState,
            idpago: parseInt(idpago, 10)
        }))
        
        setModalOpeningMode('EDITABLE')
        openModal('', 'Formulario de depositos', 'RetroactiveTransaction', {})

    }

    const onSubmitFormRetroTransaction = async (e) => {

        e.preventDefault()

        const { getCurrentDate } = Helpers
        const { FormDeposit, FormRequestGlobal } = Forms

        // Validaciones obligatorias
        if (!FormDeposit.formState.movimiento_tipo || FormDeposit.formState.movimiento_tipo === '') {
            const messageCustom = {
                message: 'Debe seleccionar un tipo de movimiento',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }
        
        // Validaciones obligatorias
        if (!FormDeposit.formState.deposito_monto || FormDeposit.formState.deposito_monto === '') {
            const messageCustom = {
                message: 'Debe especificar el monto',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }
        
        // Validaciones obligatorias
        if (!FormDeposit.formState.deposito_moneda || FormDeposit.formState.deposito_moneda === '') {
            const messageCustom = {
                message: 'Debe especificar la moneda',
                title: 'FAIL',
                rows: []
            }
            alertMessage(messageCustom)
            return
        }

        if (FormDeposit.formState.movimiento_tipo === 'DEPOSITO') {
            if (!FormDeposit.formState.idbanco || FormDeposit.formState.idbanco === 0 || FormDeposit.formState.idbanco === '') {
                const messageCustom = {
                    message: 'Debe seleccionar un banco para depósitos',
                    title: 'FAIL',
                    rows: []
                }
                alertMessage(messageCustom)
                return
            }
        }

        if (FormDeposit.formState.movimiento_tipo === 'DEPOSITO') {

            if (FormDeposit.formState.acceptedFiles.length <= 0) {

                const messageCustom = {
                    message: 'Debe cargar el comprobante para poder registrar el deposito',
                    title: 'FAIL',
                    rows: []
                }

                alertMessage(messageCustom)

                return
            }

        }

        const currentTransactions = FormRequestGlobal.formState.transactions

        console.log('[useActions][onSubmitFormRetroTransaction] currentTransactions ', currentTransactions)
        
        console.log('[useActions][onSubmitFormRetroTransaction] transactionToAdd ', FormDeposit.formState)

        const jsonBanco = JSON.parse(FormDeposit.idbanco);
        const newTransaction = {
            ...FormDeposit.formState,
            idmovimiento: nanoid(),
            idbanco: jsonBanco.idbanco,
            banco: jsonBanco.nombre,
            deposito_quetzal: FormDeposit.formState.deposito_quetzales,
            aprobacion_check: 'PENDIENTE',
            aprobacion_usuario: user.username,
            aprobacion_fecha: getCurrentDate(),
            usuario_creo: user.username,
            fecha_creo: getCurrentDate(),
            usuario_modifico: user.username,
            fecha_modifico: getCurrentDate(),
            oldRecord: false
        }

        console.log('[useActions][onSubmitFormRetroTransaction] transactionToAdd ', FormDeposit.formState)

        FormRequestGlobal.setFormState((prevState) => ({
            ...prevState,
            transactions: [
                ...prevState.transactions,
                newTransaction
            ]
        }))

        console.log('[useActions][onSubmitFormRetroTransaction] FormRequestGlobal.formState ', FormRequestGlobal.formState)

        closeModal()
        
        toast.success('Se agregó correctamente la transacción', {
            position: "top-right",
            theme: "colored"
        })

    }

    const handleClickDeleteItemFromTable = async ({itemId, paramSearch, arrayDataRowsName}) => {
        
        const { FormRequestGlobal } = Forms
        const { formState, setFormState } = FormRequestGlobal

        const newArray = formState[arrayDataRowsName].filter(item => item[itemId] !== paramSearch);
        setFormState(prevState => ({
            ...prevState,
            [ arrayDataRowsName ]: newArray
        }))

    }

    const _setRetroTransactionPreview = async (FormToLoad, payload) => {
        
        console.log('[useActions][_setRetroTransactionPreview] payload ::: ', payload)

        // Formateador de números
        const numberFormatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            maximumFractionDigits: 2
        });

        let boletaFotoPath = payload.boleta_foto_path || '';
        let boletaFotoOriginalName = payload.boleta_foto_originalname || '';

        // Si es un registro nuevo, obtener el archivo desde acceptedFiles
        if (!payload.oldRecord && payload.acceptedFiles?.length > 0) {

            const file = payload.acceptedFiles[0];

            boletaFotoPath = URL.createObjectURL(file);
            boletaFotoOriginalName = file.name;

        }
        
        FormToLoad.setFormState((prevState) => ({
            ...prevState,
            idmovimiento: payload.idmovimiento || '',
            idcaja : payload.idcaja || '',
            idbanco : payload.idbanco || '',
            boleta_numero : payload.boleta_numero || '',
            boleta_foto_path : boletaFotoPath,
            boleta_foto_originalname : boletaFotoOriginalName,
            aprobacion_referencia_ach : payload.aprobacion_referencia_ach || '',
            aprobacion_observaciones : payload.aprobacion_observaciones || '',
            aprobacion_check : payload.aprobacion_check || '',
            deposito_fecha : payload.deposito_fecha || '',
            deposito_moneda : payload.deposito_moneda || '',
            deposito_observaciones : payload.deposito_observaciones || '',
            deposito_tipo_cambio : payload.deposito_tipo_cambio || '',
            movimiento_tipo : payload.movimiento_tipo || '',
            
            deposito_monto : numberFormatter.format(payload.deposito_monto) || '',
            deposito_quetzales : numberFormatter.format(payload.deposito_quetzal) || '',
            deposito_dolares : numberFormatter.format(payload.deposito_dolares) || '',
        }))
    }

    const handleClickFetchSpecificRetroTransaction = async (idmovimiento, formOpeningMode, payload) => {

        const { setModalOpeningMode } = globalStates
        const { FormDeposit } = Forms


        const { fetchSpecificRetroTransaction } = FetchData
        const { setParamsToSearch, executeFetch } = fetchSpecificRetroTransaction

        // Reseteamos el formulario para limpiar cualquier rastro de una busqueda anterior
        FormDeposit.onResetForm()
        console.log('[useActions][handleClickFetchSpecificRetroTransaction] idmovimiento :::', idmovimiento);

        if (formOpeningMode==='EDITABLE') {
            await _setRetroTransactionPreview(FormDeposit, payload)
            setModalOpeningMode('READONLY')
            openModal('', 'Formulario de depositos', 'RetroactiveTransaction', {})
            return
        }


        // Seteamos los parametros para filtrar info y ejecutamos el fetch
        setParamsToSearch({ idmovimiento: idmovimiento })
        executeFetch()

        // setParamsToSearchDeposit({idcontrato: idcontrato})
        setModalOpeningMode('READONLY')
        openModal('', 'Formulario de depositos', 'RetroactiveTransaction', {})

    }


    return Object.freeze({
        handleClickCloseForm,
        handleChangeContract,
        onSubmitFormRequests,
        onSendLogs,
        handleClickShowModal,
        handleClickCloseModal,
        handleClickFetchInfoDeposit,
        handleChangeTypeCurrency,
        handleChangeAmount,
        handleChangeExchangeRate,
        onSubmitFormDeposits,
        onSubmitFormFiles,
        handleChangeTypeLoan,
        handleChangeTerm,
        handleChangeGPS,
        handleChangeOtros,
        handleChangeSeguro,
        handleChangeMount,
        handleClickDownloadTicket,
        handleClickResetPaymentSelection,
        handleClickFetchTransactionsByPayment,
        handleClickTransactionForRetroactive,
        onSubmitFormRetroTransaction,
        handleClickDeleteItemFromTable,
        handleClickFetchSpecificRetroTransaction
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {


    if (res) {
        const { title, message } = res
        if (title === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}